import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import * as PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import { fetchVessel } from "../../api/vessel";
import {
  setCargoDataDuration,
} from "../../model/slice/dataDurationSlice";
import dayjs from "util/dayjs-init.js";
import useInterval from "../../hooks/useInterval";
import { channelModData } from "../../model/slice/channelSlice";
import { fetchChannelModAsync } from "../../model/async/channelAsync";
import { DisplayPage } from "./displayPage";
import { DisplayTabSelector } from "./displayTabSelector";
import { calDurations } from "../../constants/calDuration";
import { NoData } from "../offlineComponent/noData";
import { PRESS_TABS } from "../../constants/cargo/constants";

export const Cargo = (props) => {
  const { vesselId, page} = useParams();
  props = {vesselId, page, ...props}; // augment props with route params to pass down to children
  const dispatch = useDispatch();
  const latestData = useSelector(channelModData);
  const [currentVessel, setCurrentVessel] = useState(null);
  const [isCargoVessel, setIsCargoVessel] = useState(false);
  const [selectedChart, setSelectedChart] = useState(PRESS_TABS.LOADING);
  const [isCargoFetching, setIsCargoFetching] = useState(false);
  const pageRef = useRef(null);

  const fetchData = async () => {
    if (isCargoFetching) return;
    setIsCargoFetching(true);
    const data = (await fetchVessel(vesselId)).vessel;
    setCurrentVessel(data);
    dispatch(fetchChannelModAsync({ vesselId }));
    setIsCargoFetching(false);
  };

  useEffect(() => {
    const startDate = dayjs.utc().subtract(1, "d").format();
    const endDate = dayjs.utc().format();
    dispatch(setCargoDataDuration({startDate, endDate, interval: calDurations({startDate, endDate})}));
    fetchData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [vesselId]);

  useEffect(() => {
    if (!currentVessel) return;

    setIsCargoVessel(currentVessel.NoTank > 0)
  }, [currentVessel]);

  useInterval(() => dispatch(fetchChannelModAsync({ vesselId })), 1000 * 60);

  return currentVessel && (
    <div style={{ overflowY: "scroll", height: "fit-content" }}>
      {isCargoVessel ?
        <>
          <DisplayTabSelector {...props} pageRef={pageRef} selectedChart={selectedChart}/>
          <DisplayPage {...props} pageRef={pageRef} latestData={latestData} selectedChart={selectedChart} setSelectedChart={setSelectedChart}/>
        </>
      : <div style={{ width: "100%", height: "500px" }}>
          <NoData />
        </div>
      }
    </div>
  );
};

Cargo.propTypes = {
  vesselId: PropTypes.string,
  page: PropTypes.string,
};
